import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';

import WarningIcon from '@mui/icons-material/Warning';

interface BrowserErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  gameType?: 'memory' | 'slot' | 'miner' | 'maze';
}

const BrowserErrorModal: FC<BrowserErrorModalProps> = ({ isOpen, onClose, gameType = 'memory' }) => {
  const { t } = useTranslation();

  // Определяем ключ перевода в зависимости от типа игры
  const getTranslationKey = () => {
    switch (gameType) {
      case 'slot':
        return 'clientSlot.browserError';
      case 'miner':
        return 'clientMiner.browserError';
      case 'maze':
        return 'clientMaze.browserError';
      default:
        return 'clientMemory.browserError';
    }
  };

  const translationKey = getTranslationKey();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6" component="span">
            {t(`${translationKey}.title`)}
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent sx={{ pb: 2 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            {t(`${translationKey}.message`)}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {t(`${translationKey}.solution`)}
          </Typography>
        </Alert>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ minWidth: 120 }}
        >
          {t(`${translationKey}.buttonText`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrowserErrorModal;
